export const API_ENDPOINTS = {
  GET_ROLES_BY_ORG: (data) => `/role/rolesByGroupId/${data}`,
  ACCESS_TYPE: () => `/roles/access-type`,
  // get employee based parent org
  GET_EMPLOYEE: () => `/employee/getActiveEmp-parentOrg`,
  // get reviewer based (employee list)
  GET_REVIWER: () => `/employee/reviewer-list`,
  // get rep based (employee list)

  GET_REVIEWER_BY_REP: (rwrId) =>
    `/employee/reporter-list?reviewerEmpId=${rwrId}`,
  // get emp based (employee list)

  GET_EMP_BY_RM: (rmId) => `/employee/emp-list?reportingManager=${rmId}`,
  ROLE_TYPE: () => `/roles/org-based`,
  // GET_ORGANIZATION: () => `/organization/options?isParent=1`,
  GET_ORG_BASED_EMPLOYEE: () => `/email/fetchAllEmployees`,
  ADD_EMPLOYEE: () => `/employee`,
  EMPLOYEE_LIST: () => `/employee/filter`,
  DOWNLOAD: (org) => `/employee/downloadSampleFile`,
  BULK_UPLOAD: (opt) => `/employee/bulk-upload?operation=${opt}`,

  EDIT_ROLE: (employeeId) =>
    `/employee/edit-role-type?employeeId=${employeeId}`,
  EDIT_ORGANAZATION: (empId) => `/employee/${empId}/editorgsAndSubOrgs`,

  // get org
  GET_SUB_ORG: (org) =>
    `/organization/{parentId}/sub-orgs?parentOrganizationCode=${org}`,
  GET_ORG: ({ parentOrg, isParent }) => {
    const queryParams = new URLSearchParams();
    if (parentOrg) queryParams.append("parentOrg", parentOrg);
    if (isParent) queryParams.append("isParent", isParent);
    return `organization/options?${queryParams.toString()}`;
  },
  // id card
  EDIT_ID_CARD_INFO: (empId) => `/card/info/${empId}`,

  // MOVEMENT
  GET_RM_UNDER_RW: (empId) => `/movement/empCode-underRM?empId=${empId}`,
  GET_EMP_UNDER_RM: (empId) => `/employee/by-primary-manager/${empId}`,
  POST_ID_CARD: (
    empId,
    empRelation,
    nameOfRelation,
    contactNo,
    bloodGroup,
    status
  ) => {
    const queryParams = new URLSearchParams();
    if (empId) queryParams.append("empId", empId);
    if (empRelation) queryParams.append("empRelation", empRelation);
    if (nameOfRelation) queryParams.append("nameOfRelation", nameOfRelation);
    if (contactNo) queryParams.append("contactNo", contactNo);
    if (bloodGroup) queryParams.append("bloodGroup", bloodGroup);
    if (status) queryParams.append("status", status);
    return `employee/update-idCardByHr?${queryParams.toString()}`;
  },
  // get Recruiter && On Boarder && Buddy

  GET_REC: (role) => `/role/fetchByRole?role=${role}`,
  // rwr by rm
  GET_REVIEWER_BY_RM: (rmId) => `/employee/get-manager-id/${rmId}`,
  GET_DIVISION_BY_DEPT: (dept) => `/employee/get-division-head/${dept}`,

  // mail id domain based org list
  GET_DOMAIN_BASED_ORG_LIST: () => `/organization/active-org-list`,

  // export
  EXPORT: () => `/employee/excel`,

  //POST SPOC
  ADD_SPOC: () => `/employee/spoc`,
};
